import { API, APIError } from ".";
import type { OpenAPI } from "../../interfaces";

export const connections = (api: API) => ({
  getConnectedEntitiesForContext(
    entity: string,
    service: string,
    contextId: string,
    success: (
      response: OpenAPI.GET<"/connections/{entity}/{service}/{context_id}">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/connections/${entity}/${service}/${contextId}`,
      null,
      success,
      fail,
    );
  },
  removeConnection(
    entity: string,
    service: string,
    contextId: string,
    entityId: string,
    success: (
      response: OpenAPI.DELETE<"/connections/{entity}/{service}/{context_id}/{entity_id}">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "DELETE",
      `/connections/${entity}/${service}/${contextId}/${entityId}`,
      null,
      success,
      fail,
    );
  },
});
